module.exports = __webpack_public_path__ + "static/cocatus-logo-ccc7d66da25e0514ce5b725b086137b6.png";